import { render, staticRenderFns } from "./FillerOptionBox.vue?vue&type=template&id=fdd712c6&scoped=true"
import script from "./FillerOptionBox.vue?vue&type=script&lang=js"
export * from "./FillerOptionBox.vue?vue&type=script&lang=js"
import style0 from "./FillerOptionBox.vue?vue&type=style&index=0&id=fdd712c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdd712c6",
  null
  
)

export default component.exports